/**
 *
 * FuturaIllustrationPage
 *
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash/object';
import { FormattedMessage } from 'react-intl';
import {
  useHistory,
  useLocation,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import globalMessages from 'containers/App/messages';
import { Grid, Typography, Button } from '@material-ui/core';
import FormHeader from 'components/FormHeader';
import FormFooter from 'components/FormFooter';
import { makeSelectSubPage } from 'containers/DashboardPage/selectors';
import {
  changeSubPageAction,
  changeSubPageListAction,
} from 'containers/DashboardPage/actions';
import Dialog from 'components/Dialog';
import { submit } from 'redux-form';
import {
  makeSelectOption,
  makeSelectAgentDetails,
  makeSelectOfferCodeData,
  makeSelectErrorOfferCodeData,
} from 'containers/App/selectors';
import FormMainBody from 'components/FormMainBody';
import { isEmpty, find, isEqual } from 'lodash';
import { usePrevious } from 'utils/hooks';
import { resetProductConfigAction } from 'containers/IllustrationPage/actions';
import { fromJS } from 'immutable';
import NoticeBox from 'components/NoticeBox';
import { getCoverages } from './helper';
import LifeAssuredForm from './components/LifeAssuredForm';
import {
  ChangeLifeAssuredAction,
  ChangeCoverageAction,
  createQuoteAction,
  calculateQuoteAction,
  setErrorAction,
  SetCoveragesListAction,
  getQuoteAction,
  updateStatusAction,
  resetAction,
  createApplicationAction,
  setFuturaConfigAction,
  setQuoteAction,
  setPtvVersionAction,
  getFiaAction,
  setPremiumTermAction,
  cloneQuoteAction,
  setCloneStatusAction,
  setCompletedDialogAction,
  setProductCodeAction,
} from './actions';
import {
  makeSelectLifeAssured,
  makeSelectProductConfig,
  makeSelectError,
  makeSelectConfig,
  makeSelectStatus,
  makeSelectApplicationId,
  makeSelectQuoteId,
  makeSelectFiaCharge,
  makeSelectInitialLifeAssured,
  makeSelectCloneStatus,
  makeSelectCompletedDialog,
  makeSelectIsCalculateQuotePage,
} from './selectors';
import Review from './components/Review';
import BenefitRatingForm from './components/BenefitRatingForm';
import QuoteForm from './components/QuoteForm';
import CoverageForm from './components/CoverageForm';
import messages from './messages';
import saga from './saga';
import reducer from './reducer';
import { makeSelectProductConfig as makeSelectProductConfig2 } from 'containers/IllustrationPage/selectors';

const subPageListfutura = [
  { order: 1, text: 'Life Insured', subOrder: [] },
  { order: 2, text: 'Coverage', subOrder: [] },
  { order: 3, text: 'Quote', subOrder: [] },
  { order: 4, text: 'Review', subOrder: [] },
];

export function FuturaIllustrationPage({
  quoteId,
  saveQuote,
  calculateQuote,
  setCoverage,
  setQuoteId,
  futuraConfig,
  setfuturaConfig,
  subPage,
  changeSubPage,
  changeSubPageList,
  isCalculateQuotePage,
  lifeAssured,
  initialLifeAssured,
  changeLifeAssured,
  productConfig,
  changeCoverage,
  submitLifeAssured,
  submitCoverage,
  submitQuote,
  submitBenefitRating,
  options,
  getQuote,
  updateStatus,
  errorData,
  applicationId,
  status,
  createApplication,
  setError,
  resetData,
  resetProductConfig,
  agentDetails,
  setPtvVersion,
  fiaData,
  callFia,
  changePolicyCoverTerm,
  cloneQuote,
  cloneStatus,
  changeCloneStatus,
  offerCodeData,
  completedDialog,
  setCompletedDialog,
  offerCodeErrorMsg,
  setProductCode,
  productConfig2,
}) {
  useInjectReducer({ key: 'futuraIllustrationPage', reducer });
  useInjectSaga({ key: 'futuraIllustrationPage', saga });
  const history = useHistory();
  const location = useLocation();

  const [product, setProduct] = useState({});
  const [isLifeAssuredEqual, setLifeAssuredEqual] = useState(false);
  const [isAlreadyReverse, setReverseCalculation] = useState(false);

  if (applicationId) {
    changeSubPage(0);
    history.replace(`/applications/${applicationId}`);
    resetProductConfig();
  }

  useEffect(() => {
    if (status === 'AGREED') {
      createApplication();
    }

    if ((status === 'SAVED' || status === 'PREVIEW') && !isEmpty(quoteId)) {
      history.replace('/illustrations/futura/review', location.state);
    }
  }, [status]);

  const prevPremium = usePrevious(productConfig.premium);
  useEffect(() => {
    if (
      productConfig.premium != undefined &&
      productConfig.premium != 0 &&
      productConfig.premium != prevPremium
    ) {
      return history.replace('/illustrations/futura/quote', location.state);
    }

    if (
      !isCalculateQuotePage &&
      productConfig.premium == undefined &&
      location.pathname === '/illustrations/futura/quote'
    ) {
      return history.replace('/illustrations/futura/coverage', location.state);
    }
  }, [productConfig.premium]);

  useEffect(() => {
    if (cloneStatus) {
      history.replace({
        pathname: '/illustrations/futura',
        state: { futuraConfig, quoteId, type: 2 },
      });
      getQuote(2);
      changeCloneStatus(false);
    }
  }, [cloneStatus]);

  const prevfuturaConfig = usePrevious(futuraConfig);

  useEffect(() => {
    if (isEmpty(prevfuturaConfig) && !isEmpty(futuraConfig))
      setCoverage(getCoverages(futuraConfig.features));

    if (futuraConfig.productCode) {
      const productDetails = find(
        agentDetails.products,
        p => p.productId === futuraConfig.productCode,
      );
      setPtvVersion(productDetails?.PTVVersion);
      setProductCode(productDetails?.PTVCode);
      setProduct(productDetails);
    }
  }, [futuraConfig]);

  useEffect(() => {
    setfuturaConfig(location.state.futuraConfig);
    if (location.state.futuraConfig.features.haveFiaCharge) callFia();

    if (location.state.quoteId) {
      setQuoteId(location.state.quoteId);
      getQuote(location.state.type);
    }

    changeSubPageList(subPageListfutura);
    return () => {
      changeSubPage(0);
      changeSubPageList([]);
      resetData();
    };
  }, []);

  useEffect(() => {
    let activeSubPage = subPage;
    switch (location.pathname) {
      case '/illustrations/futura/insured':
        activeSubPage = 1;
        break;
      case '/illustrations/futura/coverage':
        activeSubPage = 2;
        break;
      case '/illustrations/futura/benefitrating':
        activeSubPage = 2;
        break;
      case '/illustrations/futura/quote':
        activeSubPage = 3;
        break;
      case '/illustrations/futura/review':
        activeSubPage = 4;
      default:
        break;
    }
    changeSubPage(activeSubPage);
  }, [location.pathname]);

  useEffect(() => {
    if (errorData.error) window.scrollTo(0, 0);
  }, [errorData]);

  useEffect(() => {
    if (!isEmpty(location.state.customerDetail)) {
      changeLifeAssured({
        ...lifeAssured,
        insuredOne: location.state.customerDetail,
      });
    }
  }, []);

  const getTitle = () => {
    switch (location.pathname) {
      case '/illustrations/futura/insured':
        return globalMessages.lifeAssuredTitle;
      case '/illustrations/futura/coverage':
        return globalMessages.coverageTitle;
      case '/illustrations/futura/benefitrating':
        return globalMessages.benefitRatingTitle;
      case '/illustrations/futura/quote':
        return globalMessages.quoteTitle;
      case '/illustrations/futura/review':
        return globalMessages.reviewTitle;
      default:
        return globalMessages.lifeAssuredTitle;
    }
  };

  const getFooterLabel3 = () => {
    switch (location.pathname) {
      case '/illustrations/futura/quote':
        return globalMessages.saveQuote;
      case '/illustrations/futura/review':
        return globalMessages.agreeAndProceed;
      default:
        return globalMessages.next;
    }
  };

  return (
    <>
      <FormHeader
        title={<FormattedMessage {...getTitle()} />}
        productName={futuraConfig?.shortName}
      />

      {errorData.error ? (
        <Grid container style={{ paddingLeft: '40px' }}>
          <Grid item xs={7}>
            <NoticeBox variant="error" mb={4}>
              {errorData.message.map((error, index) => (
                <Typography
                  key={index}
                  id={error.message}
                  variant="body2"
                  color="error"
                >
                  {error.message}
                </Typography>
              ))}
            </NoticeBox>
          </Grid>
        </Grid>
      ) : null}

      <FormMainBody>
        <Grid item xs={12} md={10} lg={7} xl={6}>
          <Switch>
            <Route
              path="/illustrations/futura/insured"
              render={() => (
                <LifeAssuredForm
                  initialValues={lifeAssured}
                  disabled={!!quoteId}
                  location={location}
                  options={options}
                  futuraConfig={futuraConfig}
                  onSubmit={immutableValues => {
                    const currentLifeAssured = immutableValues.toJS();
                    let isLaOneEqual = false;
                    let isLaTwoEqual = false;
                    let isInsuredTwoEqual = false;
                    let isPoEqual = false;
                    let isPoValueEqual = false;

                    if (
                      isEqual(
                        initialLifeAssured.insuredOne,
                        currentLifeAssured.insuredOne,
                      )
                    )
                      isLaOneEqual = true;

                    if (
                      isEqual(
                        initialLifeAssured.insuredTwo,
                        currentLifeAssured.insuredTwo,
                      )
                    )
                      isLaTwoEqual = true;

                    if (
                      initialLifeAssured.isInsuredTwo ===
                      currentLifeAssured.isInsuredTwo
                    )
                      isInsuredTwoEqual = true;

                    if (
                      initialLifeAssured.isPolicyOwnerIndividual ===
                      currentLifeAssured.isPolicyOwnerIndividual
                    )
                      isPoEqual = true;

                    if (
                      isEqual(
                        initialLifeAssured.policyOwnerIndividual,
                        currentLifeAssured.policyOwnerIndividual,
                      )
                    )
                      isPoValueEqual = true;

                    if (
                      !initialLifeAssured.isInsuredTwo &&
                      !currentLifeAssured.isInsuredTwo
                    )
                      isLaTwoEqual = true;

                    if (
                      !initialLifeAssured.isPolicyOwnerIndividual &&
                      !currentLifeAssured.isPolicyOwnerIndividual
                    )
                      isPoValueEqual = true;

                    if (
                      isLaOneEqual &&
                      isLaTwoEqual &&
                      isInsuredTwoEqual &&
                      isPoEqual &&
                      isPoValueEqual
                    ) {
                      setLifeAssuredEqual(true);
                    }

                    changeLifeAssured(immutableValues.toJS());
                    return history.replace(
                      '/illustrations/futura/coverage',
                      location.state,
                    );
                  }}
                />
              )}
            />

            <Route
              path="/illustrations/futura/coverage"
              render={() => (
                <CoverageForm
                  initialValues={{
                    ...productConfig,
                    shortName: productConfig2.shortName,
                    FMC: get(
                      find(productConfig2.features?.FMC, f => {
                        return f.region === agentDetails.ISOCountryCode;
                      }),
                      'FMCrate',
                      '',
                    ),
                  }}
                  location={location}
                  lifeAssured={lifeAssured}
                  options={options}
                  product={product}
                  agentDetails={agentDetails}
                  offerCodeData={offerCodeData}
                  futuraConfig={futuraConfig}
                  fiaData={fiaData}
                  onSubmit={immutableValues => {
                    if (immutableValues.toJS().specialTermsFlag) {
                      changeCoverage(
                        immutableValues,
                        false,
                        false,
                        false,
                        isLifeAssuredEqual,
                      );
                      return history.replace(
                        '/illustrations/futura/benefitrating',
                        location.state,
                      );
                    }
                    changeCoverage(
                      immutableValues,
                      true,
                      false,
                      false,
                      isLifeAssuredEqual,
                    );
                  }}
                />
              )}
            />

            <Route
              path="/illustrations/futura/benefitrating"
              render={() => (
                <BenefitRatingForm
                  initialValues={productConfig}
                  lifeAssured={lifeAssured}
                  onSubmit={immutableValues => {
                    changeCoverage(
                      immutableValues,
                      true,
                      false,
                      false,
                      isLifeAssuredEqual,
                    );
                  }}
                />
              )}
            />

            <Route
              path="/illustrations/futura/quote"
              render={() => (
                <QuoteForm
                  initialValues={productConfig}
                  location={location}
                  lifeAssured={lifeAssured}
                  options={options}
                  product={product}
                  originalPremium={productConfig.premium}
                  futuraConfig={futuraConfig}
                  agentDetails={agentDetails}
                  calculateQuote={val => calculateQuote(val)}
                  onUpdateValues={(
                    newValues,
                    reverseCalculate,
                    isCheckOfferCode = false,
                  ) => {
                    setReverseCalculation(reverseCalculate);

                    if (isAlreadyReverse && !reverseCalculate) {
                      changePolicyCoverTerm('WholeOfLife');
                      newValues.policyCoverTerm = 'WholeOfLife';
                    }

                    changeCoverage(
                      fromJS(newValues),
                      true,
                      reverseCalculate,
                      true,
                      isLifeAssuredEqual,
                      isCheckOfferCode,
                    );
                  }}
                  onSubmit={immutableValues => {
                    return saveQuote({ isAlreadyReverse, isLifeAssuredEqual });
                  }}
                  offerCodeData={offerCodeData}
                />
              )}
            />

            <Route
              path="/illustrations/futura/review"
              render={() => (
                <Review
                  initProductConfig={productConfig}
                  location={location}
                  onClickBackToClientList={() =>
                    setCompletedDialog({ open: true, message: 'EXIT' })
                  }
                />
              )}
            />

            <Route
              path="/"
              render={() => (
                <Redirect
                  to={{
                    pathname:
                      isEmpty(quoteId) || location.state.type === 2
                        ? '/illustrations/futura/insured'
                        : '/illustrations/futura/review',
                    state: location.state,
                  }}
                />
              )}
            />
          </Switch>
        </Grid>
      </FormMainBody>
      <FormFooter
        onClickPrevious={() => {
          setError({ error: false, message: [] });
          switch (location.pathname) {
            case '/illustrations/futura/insured':
              history.replace('/illustrations');
              break;
            case '/illustrations/futura/coverage':
              history.replace('/illustrations/futura/insured', location.state);
              break;
            case '/illustrations/futura/benefitrating':
              history.replace('/illustrations/futura/coverage', location.state);
              break;
            case '/illustrations/futura/quote':
              productConfig.specialTermsFlag
                ? history.replace(
                    '/illustrations/futura/benefitrating',
                    location.state,
                  )
                : history.replace(
                    '/illustrations/futura/coverage',
                    location.state,
                  );
              break;
            default:
              break;
          }
          return changeSubPage(subPage - 1);
        }}
        onClickExit={() =>
          // changeSubPage(0);
          // resetProductConfig();
          // return history.replace('/illustrations');
          setCompletedDialog({
            open: true,
            message: 'EXIT',
          })
        }
        onClickNext={() => {
          setError({ error: false, message: [] });
          switch (location.pathname) {
            case '/illustrations/futura/insured':
              submitLifeAssured();
              break;
            case '/illustrations/futura/coverage':
              submitCoverage();
              break;
            case '/illustrations/futura/benefitrating':
              submitBenefitRating();
              break;
            case '/illustrations/futura/quote':
              submitQuote();
              break;
            case '/illustrations/futura/review':
              return updateStatus(2);
              break;
            default:
              break;
          }
        }}
        disabledPrevious={
          location.pathname === '/illustrations/futura/insured' ||
          location.pathname === '/illustrations/futura/review'
        }
        disabledNext={
          (location.pathname === '/illustrations/futura/review' &&
            status != 'PREVIEW') ||
          (location.pathname === '/illustrations/futura/review' &&
            offerCodeData.errorMessage) ||
          offerCodeData.validating ||
          (location.pathname === '/illustrations/futura/quote' &&
            !isEmpty(offerCodeErrorMsg)) ||
          (location.pathname === '/illustrations/futura/quote' &&
            errorData.error)
        }
        label1={<FormattedMessage {...globalMessages.previous} />}
        label2={<FormattedMessage {...globalMessages.exit} />}
        label3={<FormattedMessage {...getFooterLabel3()} />}
      />

      <Dialog
        open={completedDialog.open}
        onClose={() =>
          setCompletedDialog({
            ...completedDialog,
            open: false,
          })
        }
        onExited={() =>
          setCompletedDialog({
            ...completedDialog,
            message: null,
          })
        }
        variant={completedDialog.message === 'EXIT' ? 'error' : 'success'}
        title={
          <FormattedMessage
            {...(completedDialog.message === 'EXIT'
              ? globalMessages.warning
              : messages.added)}
          />
        }
        actions={
          <Grid
            container
            alignItems="center"
            wrap="nowrap"
            justify="center"
            spacing={2}
          >
            {completedDialog.message === 'ADDED' && (
              <Grid item xs={4}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setCompletedDialog({
                      open: false,
                      message: null,
                    });
                    changeSubPage(0);
                    history.replace('/illustrations');
                  }}
                >
                  <FormattedMessage {...messages.clientList} />
                </Button>
              </Grid>
            )}

            <Grid item xs={4}>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                onClick={() => {
                  setCompletedDialog({
                    open: false,
                    message: null,
                  });
                  if (completedDialog.message === 'ADDED') {
                    cloneQuote(2);
                  } else if (completedDialog.message === 'EXIT') {
                    changeSubPage(0);
                    history.replace('/illustrations');
                  }
                }}
              >
                <FormattedMessage
                  {...(completedDialog.message === 'ADDED'
                    ? messages.createAnother
                    : globalMessages.exit)}
                />
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => {
                  setCompletedDialog({
                    open: false,
                    message: null,
                  });
                  if (
                    completedDialog.message === 'ADDED' &&
                    !isEmpty(quoteId)
                  ) {
                    history.replace(
                      '/illustrations/futura/review',
                      location.state,
                    );
                  }
                }}
              >
                <FormattedMessage {...messages.continue} />
              </Button>
            </Grid>
          </Grid>
        }
      >
        <Typography variant="body1" style={{ fontWeight: 700 }}>
          <FormattedMessage {...messages.addedInfo} />
        </Typography>
      </Dialog>
    </>
  );
}

FuturaIllustrationPage.propTypes = {
  lifeAssured: PropTypes.object,
  initialLifeAssured: PropTypes.object,
  quoteId: PropTypes.string,
  applicationId: PropTypes.string,
  productConfig: PropTypes.object,
  setCoverage: PropTypes.func,
  setQuoteId: PropTypes.func,
  futuraConfig: PropTypes.object,
  setfuturaConfig: PropTypes.func,
  saveQuote: PropTypes.func,
  calculateQuote: PropTypes.func,
  subPage: PropTypes.number,
  changeSubPage: PropTypes.func,
  getQuote: PropTypes.func,
  updateStatus: PropTypes.func,
  changeSubPageList: PropTypes.func,
  changeLifeAssured: PropTypes.func,
  changeCoverage: PropTypes.func,
  submitLifeAssured: PropTypes.func,
  submitCoverage: PropTypes.func,
  submitQuote: PropTypes.func,
  submitBenefitRating: PropTypes.func,
  changePolicyCoverTerm: PropTypes.func,
  options: PropTypes.object,
  errorData: PropTypes.object,
  setError: PropTypes.func,
  status: PropTypes.string,
  resetData: PropTypes.func,
  createApplication: PropTypes.func,
  resetProductConfig: PropTypes.func,
  agentDetails: PropTypes.object,
  setPtvVersion: PropTypes.func,
  callFia: PropTypes.func,
  fiaData: PropTypes.object,
  cloneQuote: PropTypes.func,
  cloneStatus: PropTypes.bool,
  changeCloneStatus: PropTypes.func,
  offerCodeData: PropTypes.object,
  completedDialog: PropTypes.object,
  setCompletedDialog: PropTypes.func,
  isCalculateQuotePage: PropTypes.bool,
  offerCodeErrorMsg: PropTypes.string,
  setProductCode: PropTypes.func,
  productConfig2: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  subPage: makeSelectSubPage(),
  fiaData: makeSelectFiaCharge(),
  quoteId: makeSelectQuoteId(),
  futuraConfig: makeSelectConfig(),
  lifeAssured: makeSelectLifeAssured(),
  initialLifeAssured: makeSelectInitialLifeAssured(),
  productConfig: makeSelectProductConfig(),
  options: makeSelectOption(),
  errorData: makeSelectError(),
  status: makeSelectStatus(),
  applicationId: makeSelectApplicationId(),
  agentDetails: makeSelectAgentDetails(),
  cloneStatus: makeSelectCloneStatus(),
  offerCodeData: makeSelectOfferCodeData(),
  completedDialog: makeSelectCompletedDialog(),
  isCalculateQuotePage: makeSelectIsCalculateQuotePage(),
  offerCodeErrorMsg: makeSelectErrorOfferCodeData(),
  productConfig2: makeSelectProductConfig2(),
});

function mapDispatchToProps(dispatch) {
  return {
    saveQuote: value => dispatch(createQuoteAction(value)),
    setfuturaConfig: value => dispatch(setFuturaConfigAction(value)),
    setCoverage: value => dispatch(SetCoveragesListAction(value)),
    calculateQuote: value => dispatch(calculateQuoteAction(value)),
    changeSubPage: value => dispatch(changeSubPageAction(value)),
    changeSubPageList: value => dispatch(changeSubPageListAction(value)),
    changeLifeAssured: value => dispatch(ChangeLifeAssuredAction(value)),
    callFia: () => dispatch(getFiaAction()),
    changePolicyCoverTerm: val => dispatch(setPremiumTermAction(val)),
    cloneQuote: value => dispatch(cloneQuoteAction(value)),
    changeCloneStatus: value => dispatch(setCloneStatusAction(value)),
    changeCoverage: (
      value,
      reacalculateQuote = false,
      reverseCalculate = false,
      isCalculateQuotePage = false,
      isLifeAssuredEqual,
      isCheckOfferCode = false,
    ) =>
      dispatch(
        ChangeCoverageAction(
          value,
          reacalculateQuote,
          reverseCalculate,
          isCalculateQuotePage,
          isLifeAssuredEqual,
          isCheckOfferCode,
        ),
      ),
    updateStatus: val => dispatch(updateStatusAction(val)),
    getQuote: value => dispatch(getQuoteAction(value)),
    setQuoteId: value => dispatch(setQuoteAction(value)),
    resetData: () => dispatch(resetAction()),
    setError: value => dispatch(setErrorAction(value)),
    resetProductConfig: () => dispatch(resetProductConfigAction()),
    createApplication: value => dispatch(createApplicationAction(value)),
    setPtvVersion: value => dispatch(setPtvVersionAction(value)),
    submitLifeAssured: () => dispatch(submit('lifeAssuredForm')),
    submitCoverage: () => dispatch(submit('coverageForm')),
    submitBenefitRating: () => dispatch(submit('benefitRatingForm')),
    submitQuote: () => dispatch(submit('quoteForm')),
    setCompletedDialog: value => dispatch(setCompletedDialogAction(value)),
    setProductCode: value => dispatch(setProductCodeAction(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(FuturaIllustrationPage);
